export const iconFontAwesomeUsersPeoplePeopleCarryBox = (
	<i className="fa-solid fa-people-carry-box"></i>
);
